module.exports = __webpack_public_path__ + "static/media/infoIcon.47968c91.svg";